import { SkipForwardIcon } from './SkipForwardIcon';

/**
 * author: Simran
 * id 760EA0AB-7906-4FA4-86E0-CD18A4073302
 * name skip-forward
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/skip-forward.svg
 * tags
 * - Home Automation 
 */
export const NextTitleIcon = SkipForwardIcon;
export default NextTitleIcon